import resources from './resources';

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: process.env.REACT_APP_LANGUAGE || 'en',
  resources,
};

export { resources };
